import { initReactInAuthorMode, registerReactComponent } from '@react/react-component-registry'
import { SearchResults } from '@react/SearchResults'

registerReactComponent('SearchResults', SearchResults)
initReactInAuthorMode({ component: SearchResults, componentName: 'SearchResults' })
